/**
 * OVILIP Card Swatch Interactivity
 */
document.addEventListener('DOMContentLoaded', () => {
  function setupOvilipSwatches() {
    document.querySelectorAll('.ovilip-card-swatches').forEach(swatchContainer => {
      const card = swatchContainer.closest('.card-wrapper');
      if (!card) return;

      const mainImg = card.querySelector('.card__media img:first-child');
      const cardLinks = card.querySelectorAll('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"], .card__heading a');
      const swatches = swatchContainer.querySelectorAll('.ovilip-card-swatch-item');

      swatches.forEach(swatch => {
        const updateVariant = () => {
          const imgUrl = swatch.getAttribute('data-variant-img');
          const variantUrl = swatch.getAttribute('data-variant-url');

          if (imgUrl && mainImg) {
            mainImg.src = imgUrl;
            if (mainImg.srcset) {
              mainImg.srcset = imgUrl;
            }
          }

          if (variantUrl && cardLinks.length) {
            cardLinks.forEach(link => {
              link.href = variantUrl;
            });
          }

          swatches.forEach(s => s.classList.remove('active'));
          swatch.classList.add('active');
        };

        swatch.addEventListener('mouseenter', updateVariant);
        swatch.addEventListener('click', (e) => {
          updateVariant();
        });
      });
    });
  }

  setupOvilipSwatches();
  document.addEventListener('shopify:section:load', setupOvilipSwatches);
});
